export default "__VITE_ASSET__nM9ukh1c__"